const slides = document.querySelectorAll('.slider--slide');
const dotContainer = document.querySelector('.codecapo--slider-dots');
const sliderContainer = document.querySelector('.slides-container');
let counter = 0;
let startX = 0;
let endX = 0;


slides.forEach((slide, index) => {
  slide.style.left = `${index * 100}%`;
});


slides.forEach((_, index) => {
  const dot = document.createElement('button');
  dot.classList.add('dot');
  if (index === 0) dot.classList.add('active'); // Set first dot as active
  dot.addEventListener('click', () => {
    counter = index;
    slideImage();
  });
  dotContainer.appendChild(dot);
});


const updateActiveDot = () => {
  document.querySelectorAll('.dot').forEach((dot, index) => {
    dot.classList.toggle('active', index === counter);
  });
};

const getPrev = () => {
  if (counter > 0) {
    counter--;
  } else {
    counter = slides.length - 1; 
  }
  slideImage();
};

const getNext = () => {
  if (counter < slides.length - 1) {
    counter++;
  } else {
    counter = 0; 
  }
  slideImage();
};

const slideImage = () => {
  slides.forEach((slide) => {
    slide.style.transform = `translateX(-${counter * 100}%)`;
  });
  updateActiveDot(); 
};

// 🌟 Add Mobile Swipe Support
sliderContainer.addEventListener("touchstart", (e) => {
  startX = e.touches[0].clientX; 
});

sliderContainer.addEventListener("touchend", (e) => {
  endX = e.changedTouches[0].clientX; 
  handleSwipe();
});

const handleSwipe = () => {
  let swipeDistance = startX - endX;

  if (swipeDistance > 50) {
    getNext();
  } else if (swipeDistance < -50) {
    getPrev();
  }
};
